import React from 'react';
import { Button } from "@/components/ui/button";
import { Pencil, Trash2 } from "lucide-react";
import { WorkspaceList } from './WorkspaceList';

interface OrganizationItemProps {
  organization: {
    id: string;
    name: string;
    workspaces: Array<{
      id: string;
      name: string;
      boards: Array<{
        id: string;
        name: string;
      }>;
    }>;
  };
  onRename: (type: 'organization' | 'workspace' | 'board', id: string, name: string) => void;
  onDelete: (type: 'organization' | 'workspace' | 'board', id: string, name: string) => void;
}

export const OrganizationItem: React.FC<OrganizationItemProps> = ({
  organization,
  onRename,
  onDelete,
}) => {
  return (
    <div key={organization.id} className="mb-8">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-xl font-semibold">{organization.name}</h2>
        <div className="flex gap-2">
          <Button
            variant="ghost"
            size="icon"
            onClick={() => onRename('organization', organization.id, organization.name)}
          >
            <Pencil className="h-4 w-4" />
          </Button>
          <Button
            variant="ghost"
            size="icon"
            onClick={() => onDelete('organization', organization.id, organization.name)}
          >
            <Trash2 className="h-4 w-4" />
          </Button>
        </div>
      </div>

      <div className="space-y-4 pl-4">
        <WorkspaceList
          workspaces={organization.workspaces}
          onRename={onRename}
          onDelete={onDelete}
        />
      </div>
    </div>
  );
};